import actions from './actionTypes';
import * as api from '../services/api';
import { setCurrentPageIndex } from './pageControllerActions';
import {
  openLinkInCurrentTab,
  getOnlyDreamstimePlacings
} from '../utilities/HelperFunctions/HelperFunctions';
import { getPrinitingOptionKey } from '../utilities/CookieUtils/CookieUtils';
import { setMessageDialogParams } from './fabricCanvasActions';
import { string } from '../localization';
import { setDreamstimeUserLoggedIn } from './modalActions';
import { getDreamstimePrice } from './sideBarActions';
import {
  sendPrintGA,
  GAForSelectedRIP
} from '../utilities/GAHelpers/GAHelpers';
import * as Constants from '../utilities/constants/Constants';
import { triggerRedrawAfterDataFetch } from './sideBarActionHelpers';
import { getPlacings } from './ProjectData/Project';

export const handleVecteezyLoginWindow = state => dispatch => {
  dispatch({
    type: actions.VECTEEZY_LOGIN_WINDOW,
    payload: { value: state }
  });
  dispatch(setLoginErrorMessage(''));
};

export const handlePatternDesignLoginWindow = state => dispatch => {
  dispatch({
    type: actions.PATTERN_DESIGN_LOGIN_WINDOW,
    payload: { value: state }
  });
  dispatch(setLoginErrorMessage(''));
  if (state) {
    dispatch(handleRegisterWindowPattern(false));
  }
};

export const handleDreamstimeLoginWindow = state => dispatch => {
  dispatch({
    type: actions.DREAMSTIME_LOGIN_WINDOW,
    payload: { value: state }
  });
  dispatch(setLoginErrorMessage(''));
  if (state) {
    dispatch(handleRegisterWindowDreamstime(false));
  }
};

export const handleRegisterWindowDreamstime = state => dispatch => {
  dispatch({
    type: actions.REGISTER_WINDOW_DREAMSTIME,
    payload: { value: state }
  });
  if (state) {
    dispatch(handleDreamstimeLoginWindow(false));
  }
};

export const handleRegisterWindowPattern = state => dispatch => {
  dispatch({
    type: actions.REGISTER_WINDOW_PATTERN,
    payload: { value: state }
  });
  if (state) {
    dispatch(handlePatternDesignLoginWindow(false));
  }
};

export const registerAccount = data => (dispatch, getState) => {
  const formData = {
    is_vanilla: true,
    store_id: getState().modal.storeData.id,
    user_data: data
  };
  const jsonAsString = JSON.stringify(formData);
  api.registerAccount(jsonAsString).then(response => {
    if (response.data.result === 'SUCCESS') {
      dispatch(postPatternDesignloginRequest(data.username, data.password));
      dispatch(handleRegisterWindowPattern(false));
    } else {
      dispatch(setRegisterAccountErrorMessage(response.data.error));
    }
  });
};

export const setRegisterAccountErrorMessage = message => dispatch => {
  dispatch({
    type: actions.REGISTER_ACCOUNT_FAILED,
    payload: { value: message }
  });
};

export const clearRegisterAccountErrorMessage = () => dispatch => {
  dispatch({
    type: actions.REGISTER_ACCOUNT_FAILED,
    payload: { value: [] }
  });
};

export const registerDreamstimeAccount = data => dispatch => {
  const requestData = JSON.stringify({
    username: data.username,
    password: data.password,
    email: data.email,
    password_confirmation: data.password_confirmation
  });

  api.registerDreamstiemAccount(requestData).then(response => {
    if (response.data.Status === 'Success') {
      dispatch(postDreamstimeloginRequest(data.username, data.password));
      dispatch(handleRegisterWindowDreamstime(false));
    } else {
      const array = [];
      array.push(response.data.ErrorMessage);
      dispatch(setRegisterAccountErrorMessage(array));
    }
  });
};

export const postVecteezyloginRequest = (username, password) => (
  dispatch,
  getState
) => {
  const storeId = getState().modal.storeData.id;
  api
    .sendVecteezyLoginCredentials(username, password, storeId)
    .then(response => {
      if (response.data.result === 'SUCCESS') {
        dispatch(handleVecteezyLoginWindow(false));
      } else {
        dispatch(setLoginErrorMessage(response.data.error));
      }
    });
};

export const postPatternDesignloginRequest = (username, password) => (
  dispatch,
  getState
) => {
  const storeId = getState().modal.storeData.id;
  api
    .sendPatterDesignLoginCredentials(username, password, storeId)
    .then(response => {
      if (response.data.result === 'SUCCESS') {
        dispatch({
          type: actions.PATTERN_DESIGN_LOGIN_SUCCESS,
          payload: { data: response.data.userData.username }
        });
        dispatch(handlePatternDesignLoginWindow(false));
      } else {
        dispatch(setLoginErrorMessage(response.data.error));
      }
    });
};

export const postDreamstimeloginRequest = (username, password) => (
  dispatch,
  getState
) => {
  const { project } = getState().finalCheck;
  const dreamstimePremiumObjects = getOnlyDreamstimePlacings(
    getPlacings(project)
  );

  const requestData = JSON.stringify({
    email: username,
    password
  });

  api.sendDreamstimeLoginCredentials(requestData).then(response => {
    if (response.data.Status == 'Success') {
      dispatch(setDreamstimeUserLoggedIn(true));
      for (let i = 0; i < dreamstimePremiumObjects.length; i++) {
        dispatch(
          getDreamstimePrice(dreamstimePremiumObjects[i].placing.placeable)
        );
      }

      dispatch(setDreamstimeUserName(() => handleDreamstimeLoginWindow(false)));
    } else {
      dispatch(setLoginErrorMessage(response.data.ErrorMessage));
    }
  });
};

export const setLoginErrorMessage = response => dispatch => {
  dispatch({
    type: actions.PREMIUM_CONTENT_LOGIN_FAILED,
    payload: { value: response }
  });
};

export const postPatternDesignLogoutRequest = () => (dispatch, getState) => {
  const storeId = getState().modal.storeData.id;
  api.sendPatterDesignLogoutRequest(storeId).then(response => {
    if (response.status === 200) {
      if (response.data.result === 'SUCCESS') {
        dispatch({
          type: actions.PATTERN_DESIGN_LOGOUT_SUCCESS
        });
      }
    }
  });
};

export const postVecteezyLogoutRequest = () => (dispatch, getState) => {
  const storeId = getState().modal.storeData.id;
  api.sendVecteezyLogoutRequest(storeId).then(response => {
    if (response.status === 200) {
      if (response.data.result === 'SUCCESS') {
        dispatch({
          type: actions.VECTEEZY_LOGOUT_SUCCESS
        });
      }
    }
  });
};

export const postDreamstimeLogoutRequest = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const dreamstimePremiumObjects = getOnlyDreamstimePlacings(
    getPlacings(project)
  );
  api
    .sendDreamstimeLogoutRequest()
    .then(response => {
      if (response.status == 200) {
        if (response.data.Status == 'Success') {
          dispatch(setDreamstimeUserLoggedIn(false));
          for (let i = 0; i < dreamstimePremiumObjects.length; i++) {
            dreamstimePremiumObjects[i].placing.placeable.costValue = 1;
          }
          dispatch(triggerRedrawAfterDataFetch());
        }
      }
    })
    .catch(() => {});
};

export const postVanillaProjectDetails = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const { id } = project;
  const email = project.emailAddress;
  const projectName = project.name;
  const lng = project.language;
  const isVanilla = getState().modal.envData.is_vanilla_designer;

  const data = {
    recipients: [email],
    name: projectName,
    print_media_name: null,
    need_install_instruction: false,
    print_additional_instructions: null,
    allow_sharing_fotolia_credentials: false,
    language: lng,
    is_vanilla_version: isVanilla
  };
  const ProjectDetails = JSON.stringify(data);
  const postData = `request=${ProjectDetails}`;
  dispatch(setCurrentPageIndex(Constants.FILE_PROCESSING_PAGE));
  dispatch(sendPrintGA(projectName))
    .then(() => {
      api.sendProjectDetails(postData, id).then(() => {
        const { token } = project;
        startPollingForPdfGeneration(
          api.getPrintConfirmation,
          token,
          dispatch,
          getState
        );
      });
    })
    .catch(() => {});
};

const handleErrorInPdfGeneration = errorMessage => dispatch => {
  dispatch(setCurrentPageIndex(Constants.FINAL_CHECK_PAGE));
  const dict = {
    header: '',
    description: errorMessage,
    stringColor: Constants.DEFAULT_STRING_COLOR,
    onclick: null,
    buttonTitles: {
      finish: string.OK_KEY,
      cancel: ''
    }
  };
  dispatch(setMessageDialogParams(dict));
};

const startPollingForPdfGeneration = (func, token, dispatch, getState) => {
  let timerId;

  async function getPrintConfirmation() {
    const selctedPrintingOption = getPrinitingOptionKey(
      getState().modal.storeData.id
    );
    let RIPName;
    if (selctedPrintingOption >= 0 && selctedPrintingOption <= 7) {
      RIPName = Constants.RIP_LIST[selctedPrintingOption].name;
    }

    func(token, RIPName).then(
      res => {
        if (res.data.result === 'SUCCESS' || res.data.result === 'ERRORED') {
          if (timerId) {
            clearInterval(timerId);
          }
          if (res.status === 200) {
            const dataJson = res.data;
            if (dataJson.result === 'ERRORED') {
              if (
                dataJson.state === 'errored_at_purchase' ||
                dataJson.state === 'pending_approval'
              ) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    dataJson,
                    'content_purchase_error'
                  ) &&
                  dataJson.content_purchase_error !== null
                ) {
                  dispatch(
                    handleErrorInPdfGeneration(dataJson.content_purchase_error)
                  );
                } else {
                  dispatch(
                    handleErrorInPdfGeneration(string.INSUFFICIENT_CREDITS_KEY)
                  );
                }
              } else {
                dispatch(
                  handleErrorInPdfGeneration(
                    string.PDF_GENERATION_ERROR_MESSAGE_KEY
                  )
                );
              }
            } else if (dataJson.result === 'SUCCESS') {
              const pdfURL = dataJson.url;
              dispatch(pollingForPdfIsCompleted(pdfURL));
            }
          } else {
            dispatch(
              handleErrorInPdfGeneration(
                string.PDF_GENERATION_ERROR_MESSAGE_KEY
              )
            );
          }
        }
      },
      () => {
        if (timerId) {
          clearInterval(timerId);
        }
      }
    );
  }

  timerId = setInterval(getPrintConfirmation, 30000);
};

const timeoutMethod = isIEBrowser => {
  if (isIEBrowser) {
    window.checkVisibilityInIE();
  } else {
    window.checkVisibility();
  }
};

const pollingForPdfIsCompleted = pdfURL => (dispatch, getState) => {
  dispatch(setCurrentPageIndex(Constants.DESIGN_SHARE_PAGE));
  const selctedPrintingOption = getPrinitingOptionKey(
    getState().modal.storeData.id
  );

  if (selctedPrintingOption >= 0 && selctedPrintingOption <= 7) {
    const RIPName = Constants.RIP_LIST[selctedPrintingOption].name;
    dispatch(GAForSelectedRIP(RIPName));
  }

  if (selctedPrintingOption === 0) {
    const newURL = `hpclick://${pdfURL}`;
    window.checkIfHasProtocol(
      newURL,
      result => {
        if (result != 'Success') {
          openLinkInCurrentTab(pdfURL);
          const dict = {
            header: 'HP Click version',
            description:
              'Please download and install the laster version of HP Click',
            stringColor: Constants.DEFAULT_STRING_COLOR,
            onclick: () => {},
            onCancel: null,
            buttonTitles: {
              finish: string.OK_KEY,
              cancel: string.CANCEL_TEXT_KEY
            }
          };
          dispatch(setMessageDialogParams(dict));
        }
      },

      () => {
        setTimeout(() => timeoutMethod(false), 1500);
      },

      () => {
        setTimeout(() => timeoutMethod(true), 1500);
      }
    );
  } else {
    openLinkInCurrentTab(pdfURL);
  }
};

export const getPrintersDetails = () => dispatch => {
  api.getPrinterModalList().then(response => {
    const printers = response.data.map(item => {
      const dict = { value: item.id, label: item.name };
      return dict;
    });

    dispatch({
      type: actions.PRINTERS_LIST,
      payload: { list: printers }
    });
  });

  api.getListOfUserType().then(response => {
    const userTypes = response.data.user_types.map((item, index) => {
      const value = { value: index, label: item };
      return value;
    });
    dispatch({
      type: actions.USER_LIST,
      payload: { list: userTypes }
    });
  });
};

export const handleAddPrinterWindow = state => dispatch => {
  dispatch({
    type: actions.SHOW_OR_HIDE_PRINTER_DETAILS_DIALOG,
    payload: { value: state }
  });
};

export const sendPrinterDetails = (serialNumber, userType, printerModelId) => (
  dispatch,
  getState
) => {
  const storeId = getState().modal.storeData.id;

  const data = {
    e_commerce_site: {
      serial_number: serialNumber,
      user_type: userType,
      printer_model_id: printerModelId
    }
  };
  const requestString = JSON.stringify(data);

  api
    .addPrinter(requestString, storeId)
    .then(postResponse => {
      if (postResponse.status === 200) {
        if (postResponse.data.result === 'FAILED') {
          dispatch({
            type: actions.FAIL_TO_ADD_PRINTER,
            payload: postResponse.data.message
          });
        } else if (postResponse.data.result === 'SUCCESS') {
          getState().modal.storeData.hasLitePartnerPrinter = true;
          dispatch(handleAddPrinterWindow(false));
        }
      }
    })
    .catch(() => {});
};

export const setDreamstimeUserName = callback => dispatch => {
  api
    .getDreamstimeAccountUserInfo()
    .then(response => {
      const info = response.data.Username;
      dispatch({
        type: actions.DREAMSTIME_USER_INFO,
        payload: { dreamstimeUserInfo: info }
      });
      dispatch(callback());
    })
    .catch(() => {});
};

export const HandleFlashMessage = value => dispatch => {
  dispatch({
    type: actions.FLASH_MESSAGE,
    payload: value
  });
};

export const setAdobeStockUserLoggedIn = state => dispatch => {
  dispatch({
    type: actions.SET_ADOBE_STOCK_USER_LOGGED_IN,
    payload: { isLoggedIn: state }
  });
};

export const adobeStockLoggedInCallback = () => dispatch => {
  dispatch(setAdobeStockUserLoggedIn(true));
  dispatch(setAdobeStockUserName());
  dispatch(triggerRedrawAfterDataFetch());
};

export const logOutFromAdobeStock = () => dispatch => {
  api
    .adobeStockLogoutRequest()
    .then(response => {
      if (response.status === 200) {
        if (response.data.result == 'SUCCESS') {
          dispatch(setAdobeStockUserLoggedIn(false));
          dispatch(triggerRedrawAfterDataFetch());
        }
      }
    })
    .catch(() => {});
};

export const setAdobeStockUserName = () => dispatch => {
  api
    .getAdobeStockAccountUserInfo()
    .then(response => {
      const data = response.data.user_data;
      dispatch({
        type: actions.ADOBE_STOCK_USER_INFO,
        payload: { adobeStockUserInfo: data.display_name }
      });
    })
    .catch(() => {});
};
